import { render, staticRenderFns } from "./CustomProductForm.vue?vue&type=template&id=1fca92fa&"
import script from "./CustomProductForm.vue?vue&type=script&lang=js&"
export * from "./CustomProductForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomProductForm.vue?vue&type=style&index=0&id=1fca92fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports